var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtlassian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_12994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.11211 11.092C7.00198 10.9482 6.83938 10.8538 6.6599 10.8296C6.48041 10.8054 6.29866 10.8534 6.15441 10.9629C6.06955 11.0299 6.00109 11.1153 5.95427 11.2128L0.0741067 22.982C-0.00917643 23.1488 -0.022856 23.3419 0.0360749 23.5187C0.0950057 23.6956 0.221724 23.8419 0.388377 23.9253C0.485789 23.9746 0.593483 24.0001 0.702647 23.9998H8.89518C9.0264 24.0031 9.15574 23.9681 9.26738 23.899C9.37902 23.83 9.4681 23.7298 9.52372 23.6109C11.2919 19.957 10.2201 14.4017 7.11211 11.092Z",
    fill: "url(#paint0_linear_46_12994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4341 0.381897C9.96828 2.63868 9.11399 5.23796 8.95508 7.9247C8.79617 10.6115 9.33811 13.2934 10.5277 15.7074L14.4776 23.6109C14.536 23.7277 14.6257 23.826 14.7367 23.8946C14.8477 23.9633 14.9756 23.9997 15.1062 23.9998H23.2971C23.3894 24 23.4809 23.982 23.5663 23.9467C23.6517 23.9114 23.7293 23.8596 23.7946 23.7943C23.8599 23.7289 23.9117 23.6513 23.947 23.5659C23.9822 23.4804 24.0002 23.3889 24 23.2965C24.0001 23.1875 23.9752 23.0799 23.9273 22.9821L12.63 0.378587C12.5764 0.265324 12.4918 0.169618 12.3859 0.102598C12.28 0.0355785 12.1574 0 12.0321 0C11.9068 0 11.7841 0.0355785 11.6783 0.102598C11.5724 0.169618 11.4878 0.265324 11.4341 0.378587V0.381897Z",
    fill: "#2684FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_12994",
    x1: 10.3491,
    y1: 12.8908,
    x2: 4.13534,
    y2: 23.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_12994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlassian);
export default __webpack_public_path__ + "static/media/atlassian.92f2f18f04a64ebbf4ba3aaabd22daed.svg";
export { ForwardRef as ReactComponent };